<script>
import {ProductCategoryProvider} from "@core/components/common/expression-language/value-provider";
import { BModal } from 'bootstrap-vue'
import Button from "@core/components/common/Button.vue";
export default {
    components: {Button, ProductCategoryProvider, BModal},
    props: {
        component: {
            required: true
        },
        statement: {
            default: null
        },
        argument: {
            required: true
        },
        arguments: {
            required: true
        },
        func: {
            required: true
        }
    },
    methods: {
        generate() {
            this.$refs.valueProvider.show();
        },
        handleGeneratedValue(value) {
            const args = '(' + this.arguments.map(a => {
                if (a === this.argument) {
                    return value;
                } else {
                    return a.name;
                }
            }) + ')';

            this.value = value;
            this.fullStatement = this.statement + args;
            this.functionStatement = '.' + this.func.name + args;

            this.$emit('generated', {
                fullStatement: this.fullStatement,
                functionStatement: this.functionStatement
            });
        }
    },
    data() {
        return {
            fullStatement: null,
            functionStatement: null,
            value: ''
        }
    }
}
</script>

<template>
    <div>
        <b-modal
            ref="valueProvider"
            cancel-variant="outline-secondary"
            centered
            hide-footer
            size="lg"
            :title="component.modalHeader"
        >
            <div v-if="fullStatement">
                <h5>Result</h5>

                <pre class="font-medium-3">{{ value }}</pre>
                <pre class="font-medium-3">{{ functionStatement }}</pre>
                <pre class="font-medium-3">{{ fullStatement }}</pre>
            </div>

            <component @input="handleGeneratedValue" :is="component.component"/>
        </b-modal>
        <Button class="btn-sm" @click="generate">Generate value</Button>
    </div>

</template>
